<template>
  <div class="ingredients" :class="{ 'view-only' : viewOnly }">
    <ag-button class="remove-set" v-if="!viewOnly" @click="removeSet" priority="secondary">Remove This Set</ag-button>
    <ag-form-group
      id="ingredient-title"
      label="Ingredients List Title"
      v-if="displayTitle && !viewOnly"
    >
      <ag-input
        id="ingredient-title"
        :value="ingredients.title"
        @blur="updateTitle($event)"
      />
    </ag-form-group>
    <h2 v-if="displayTitle && ingredients.title" class="set-title">
      {{ ingredients.title }}:
    </h2>
    <div class="items">
      <div
        class="item"
        :class="{ 'editing': editingIngredient === index }"
        v-for="(item, index) in ingredients.list"
        :key="item"
      >
        <span class="item-title" v-if="editingIngredient !== index">{{item}}</span>
        <div class="item-edit">
          <input
            id="edit-ingredient"
            class="input"
            type="text"
            :value="item"
            ref="edit"
            autocomplete="off"
            @keypress.enter="editIngredient($event.target.value, index)"
            @blur="editIngredient($event, index)"
            v-if="!viewOnly"
          />
        </div>
        <span class="item-actions" v-if="editingIngredient !== index && !viewOnly">
          <ag-button priority="secondary" @click="toggleEditMode(index)">Edit</ag-button>
          <ag-button priority="secondary" @click="removeIngredient(index)">Remove</ag-button>
          <ag-button 
            v-if="index > 0"
            priority="secondary"
            @click="reorderIngredient('up', index)"
          >Move Up</ag-button>
          <ag-button 
            v-if="index + 1 < ingredients.list.length"
            priority="secondary"
            @click="reorderIngredient('down', index)"
          >Move Down</ag-button>
        </span>
      </div>
    </div>
    <ag-form-group
      id="add-ingredient"
      label=""
      v-if="!viewOnly"
    >
      <div class="input-btn-combo" v-if="!addMultipleIngredients">
        <input
          id="add-ingredient"
          class="input"
          type="text"
          v-model="newIngredient"
          autocomplete="off"
          @keypress.enter="submitIngredient"
          placeholder="Add new ingredient"
          
        />
        <button type="button" @click="submitIngredient">+ Add</button>
      </div>
      <div v-else>
        <textarea
          id="add-ingredient"
          class="input"
          v-model="newIngredient"
          autocomplete="off"
          @blur="submitIngredient"
          placeholder="Add new ingredients"
        ></textarea>
        <button type="button" @click="submitIngredient">+ Add</button>
      </div>
    </ag-form-group>
    <ag-button
      @click="addMultiple"
      class="add-multiple"
      priority="text"
      v-if="!viewOnly"
    >
      <span v-if="!addMultipleIngredients">Add multiple ingredients at once</span>
      <span v-else>Add ingredients individually</span>
    </ag-button>
  </div>
</template>

<script>
  export default {
    name: "Ingredients",
    props: {
      ingredients: {
        type: Object,
        default: () => ({
          title: null,
          list: []
        })
      },
      setIndex: {
        type: Number,
        required: true
      },
      displayTitle: {
        type: Boolean,
        default: false
      },
      viewOnly: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      newIngredient: '',
      addMultipleIngredients: false,
      editingIngredient: null
    }),
    methods: {
      removeSet() {
        this.$emit("remove", this.setIndex);
      },
      updateTitle(title) {
        this.ingredients.title = title;
        this.$emit("title", this.ingredients, this.setIndex);
      },
      submitIngredient($event) {
        $event.preventDefault();
        const newIngredientArray = this.newIngredient && this.newIngredient.split('\n');

        if(newIngredientArray.length > 1) {
          for(let i = 0; i < newIngredientArray.length; i++) {
            if (newIngredientArray[i] === '' || !newIngredientArray[i] || this.ingredients.list.includes(newIngredientArray[i])) { return true }
            this.ingredients.list.push(newIngredientArray[i]);
          }
        } else {
          if (this.newIngredient === '' || !this.newIngredient || this.ingredients.list.includes(this.newIngredient)) { return true }
          this.ingredients.list.push(this.newIngredient);
        }
        this.$emit("enter", this.ingredients, this.setIndex);
        this.newIngredient = null;
      },
      toggleEditMode(index) {
        this.editingIngredient = index;
        this.$nextTick(() => this.$refs.edit[index].focus())
      },
      editIngredient($event, index) {
        const val = $event.target.value;
        if (val === '' || !val || this.ingredients.list.includes(val)) { 
          this.editingIngredient = null;
          return true;
        }
        this.ingredients.list.splice(index, 1, val);
        this.editingIngredient = null;
      },
      removeIngredient(item) {
        this.ingredients.list.splice(item, 1);
      },
      reorderIngredient(direction, index) {
        // remove ingredient
        var ingredient = this.ingredients.list.splice(index, 1);
        let newIndex;

        // determine where to place it back in the array
        if(direction === 'up') {
          newIndex = index === 0 ? index : index - 1;
        } else if(direction === 'down') {
          newIndex = index + 1;
        } else {
          newIndex = this.ingredients.list.length + 1;
        }

        // add ingredient back into array
        this.ingredients.list.splice(newIndex, 0, ingredient[0]);
      },
      addMultiple() {
        this.addMultipleIngredients = !this.addMultipleIngredients;
      }
    }
  };
</script>

<style scoped lang="scss">
  .input-btn-combo {
    display: inline-flex;
    align-items: center;

    input {
      margin-right: $gutter;
      flex-grow: 1;
    }
  }

  .ingredients {
    position: relative;

    .remove-set {
      position: absolute;
      top: -18px;
      right: -18px;
      padding: 6px 12px;
    }

    &.view-only {
      .items {
        margin: 0;

        .item {
          min-height: 0;
          padding: 8px 0;
          border-color: #eee;
        }
      }

      .set-title {
        border: 0;
        font-size: 18px;
      }
    }
    button {
      min-width: 80px;
    }

    .item {
      display: flex;
      align-items: center;
      min-height: 40px;
      border-bottom: $border;

      .item-title {
        margin-right: 12px;
      }

      .item-actions {
        font-size: 10px;
        visibility: hidden;
        display: flex;

        button {
          padding: 4px 8px;
          min-width: 0;
          margin: 0 4px;
        }
      }

      .item-edit {
        display: none;
      }

      &.editing {
        .item-edit {
          display: block;
        }
      }

      &:hover {
        background: rgba(0,0,0,0.02);
        .item-actions {
          visibility: visible;
        }
      }

      &:last-child {
        border-bottom: 0;
      }
    }

    .set-title {
      display: flex;
      align-items: center;
      margin: 0;
    }

    textarea {
      width: 100%;
      min-height: 60px;
    }

    .add-multiple {
      padding: 4px 0;
      margin: 0;
    }
  }
</style>
